const DashboardSite = require("@/modules/dashboard/components/DashboardSite")
  .default;

const DashboardRoutes = [
  {
    name: "dashboard.dashboard",
    path: "/dashboard",
    component: DashboardSite,
    meta: {
      requiresAuth: true,
    },
  },
];

const DashboardSettingsRoutes = [];

const DashboardBaseDataRoutes = [];

export { DashboardRoutes, DashboardSettingsRoutes, DashboardBaseDataRoutes };
